// Mock data for Maidful Employment Agency

export const services = [
  {
    id: 1,
    type: 'overseas',
    title: '海外傭工',
    filipinoPrice: '港幣 $15,800起',
    indonesianPrice: '港幣 $15,800起',
    included: [
      '海外驗身',
      '駐港領事館合約及核實',
      '香港入境處之入境工作簽証',
      '菲律賓領事館POEA核簽證',
      '印尼領事館KTKLN核簽證',
      '機場接送服務',
      '兩年合約保證',
      '免費更換服務'
    ]
  },
  {
    id: 2,
    type: 'finished',
    title: '完約現成女傭',
    filipinoPrice: '港幣 $16,800',
    indonesianPrice: '港幣 $16,800',
    included: [
      '領事館合約認證',
      '香港入境工作簽證',
      '香港驗身',
      '菲律賓領事館POEA核簽證',
      '印尼領事館KTKLN核簽證',
      '兩年合約保證',
      '免費更換服務'
    ]
  },
  {
    id: 3,
    type: 'local',
    title: '指定本地現成女傭',
    filipinoPrice: '港幣 $4,800起 (包括驗身費用)',
    indonesianPrice: '港幣 $5,800起 (包括驗身費用)',
    included: [
      '領事館合約認證',
      '香港入境工作簽證',
      '菲律賓領事館OWWA (只限菲傭)',
      '印尼領事館KTKLN核簽證',
      '香港驗身',
      '專業配對服務'
    ]
  },
  {
    id: 4,
    type: 'renewal',
    title: '續約',
    filipinoPrice: '港幣 $3,500',
    indonesianPrice: '港幣 $3,500',
    included: [
      '領事館合約認證',
      '香港入境工作簽證',
      '香港驗身',
      '菲律賓領事館POEA核簽證',
      '印尼領事館KTKLN核簽證',
      '全程跟進服務'
    ]
  }
];

export const maids = [
  {
    id: 1,
    name: 'Maria Santos',
    age: 28,
    nationality: 'Filipino',
    nationalityZh: '菲律賓',
    experience: '5年',
    skills: ['烹飪', '照顧嬰兒', '照顧長者', '家居清潔'],
    languages: ['英語', '廣東話', '國語'],
    availability: '即時',
    type: 'finished',
    image: 'https://images.unsplash.com/photo-1581065178026-390bc4e78dad?w=400&h=500&fit=crop'
  },
  {
    id: 2,
    name: 'Lina Wijaya',
    age: 26,
    nationality: 'Indonesian',
    nationalityZh: '印尼',
    experience: '3年',
    skills: ['烹飪', '照顧嬰兒', '家居清潔', '洗熨衣物'],
    languages: ['英語', '廣東話基礎'],
    availability: '2星期內',
    type: 'overseas',
    image: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=400&h=500&fit=crop'
  },
  {
    id: 3,
    name: 'Anna Cruz',
    age: 30,
    nationality: 'Filipino',
    nationalityZh: '菲律賓',
    experience: '7年',
    skills: ['烹飪', '照顧長者', '家居清潔', '駕駛'],
    languages: ['英語', '廣東話', '國語'],
    availability: '即時',
    type: 'local',
    image: 'https://images.unsplash.com/photo-1735424080768-8730f9c8a0e9?w=400&h=500&fit=crop'
  },
  {
    id: 4,
    name: 'Jessica Reyes',
    age: 27,
    nationality: 'Filipino',
    nationalityZh: '菲律賓',
    experience: '4年',
    skills: ['烹飪', '照顧嬰兒', '教導功課', '家居清潔'],
    languages: ['英語', '廣東話'],
    availability: '1星期內',
    type: 'finished',
    image: 'https://images.unsplash.com/photo-1735424080701-d00f5fda5aa6?w=400&h=500&fit=crop'
  },
  {
    id: 5,
    name: 'Siti Nurhaliza',
    age: 29,
    nationality: 'Indonesian',
    nationalityZh: '印尼',
    experience: '6年',
    skills: ['烹飪', '照顧長者', '家居清潔', '園藝'],
    languages: ['英語', '廣東話'],
    availability: '即時',
    type: 'finished',
    image: 'https://images.unsplash.com/photo-1676552055618-22ec8cde399a?w=400&h=500&fit=crop'
  },
  {
    id: 6,
    name: 'Carmen Lopez',
    age: 25,
    nationality: 'Filipino',
    nationalityZh: '菲律賓',
    experience: '2年',
    skills: ['烹飪', '照顧嬰兒', '家居清潔'],
    languages: ['英語', '廣東話基礎'],
    availability: '3星期內',
    type: 'overseas',
    image: 'https://images.unsplash.com/photo-1488510065224-1cb40f9c9f48?w=400&h=500&fit=crop'
  }
];

export const news = [
  {
    id: 1,
    title: '15 七月 2025 到港 ✈️',
    date: '2025/07/19',
    content: '恭喜多位僱主成功聘請合適的家傭！今日有5位菲律賓女傭順利抵港，感謝各位僱主的信任。',
    image: 'https://images.pexels.com/photos/34526423/pexels-photo-34526423.jpeg?w=500&h=300&fit=crop'
  },
  {
    id: 2,
    title: '08 七月 2025 到港 ✈️',
    date: '2025/07/08',
    content: '本週有8位優質女傭抵港，全部已順利與僱主會面，配對成功率100%！',
    image: 'https://images.pexels.com/photos/733856/pexels-photo-733856.jpeg?w=500&h=300&fit=crop'
  },
  {
    id: 3,
    title: '六月面試順利完成',
    date: '2025/06/28',
    content: '負責人親自到菲律賓面試多位優質姐姐，篩選最適合香港家庭的人選。海外女傭不揀工、勤力、願意學習，可信賴！',
    image: 'https://images.unsplash.com/photo-1581065178026-390bc4e78dad?w=500&h=300&fit=crop'
  },
  {
    id: 4,
    title: '特別優惠：夏季優惠計劃',
    date: '2025/06/15',
    content: '夏季特別優惠！海外女傭聘請優惠價$15,800起，包全套服務，名額有限，先到先得！',
    image: 'https://images.unsplash.com/photo-1735424080768-8730f9c8a0e9?w=500&h=300&fit=crop'
  }
];

export const faqs = [
  {
    id: 1,
    category: 'general',
    question: '聘請外傭需要多少時間？',
    answer: '一般來說，聘請海外女傭需時約8-12星期，包括簽署合約、領事館公證、入境處批核及安排到港等程序。聘請完約現成女傭則較快，約4-6星期可完成。'
  },
  {
    id: 2,
    category: 'general',
    question: '聘請外傭有甚麼基本要求？',
    answer: '僱主必須是香港居民，擁有固定住址，並能提供獨立房間給外傭居住。僱主亦需有穩定收入，以支付外傭薪金及相關開支。'
  },
  {
    id: 3,
    category: 'cost',
    question: '聘請外傭的費用包括甚麼？',
    answer: '費用包括：驗身費、領事館合約認證、入境處簽證申請、機場接送（海外女傭）、兩年合約保證及免費更換服務。'
  },
  {
    id: 4,
    category: 'cost',
    question: '外傭的每月薪金是多少？',
    answer: '根據香港政府規定，2025年外傭最低工資為港幣$5,195。僱主亦需支付膳食津貼及提供免費住宿。'
  },
  {
    id: 5,
    category: 'process',
    question: '如何挑選合適的女傭？',
    answer: '我們會根據您的家庭需要，包括家庭成員、居住環境、特別要求等，為您配對最合適的女傭。您可透過履歷、相片及視像面試了解女傭。'
  },
  {
    id: 6,
    category: 'process',
    question: '如果女傭不合適可以更換嗎？',
    answer: '可以。我們提供兩年合約保證及免費更換服務。如女傭在試用期內表現不符期望，我們會免費安排更換。'
  },
  {
    id: 7,
    category: 'visa',
    question: '外傭簽證需時多久？',
    answer: '入境處批核一般需時4-6星期。我們會全程跟進申請進度，確保順利批核。'
  },
  {
    id: 8,
    category: 'insurance',
    question: '僱主需要為外傭購買保險嗎？',
    answer: '是的。根據香港法例，僱主必須為外傭購買僱員補償保險及醫療保險。我們可協助安排合適的保險計劃。'
  }
];

export const testimonials = [
  {
    id: 1,
    name: '陳太太',
    location: '九龍塘',
    rating: 5,
    comment: '安芝僱傭中心服務非常專業，幫我找到一位很好的菲傭姐姐。姐姐勤力又細心，照顧我兩個小朋友非常好。非常感謝！',
    date: '2025/06/15'
  },
  {
    id: 2,
    name: '李先生',
    location: '中半山',
    rating: 5,
    comment: '從挑選到辦理所有手續都很順利，職員很專業和耐心解答所有問題。女傭準時到港，表現非常好。強烈推薦！',
    date: '2025/05/28'
  },
  {
    id: 3,
    name: '黃太太',
    location: '西貢',
    rating: 5,
    comment: '我媽媽年紀大需要人照顧，安芝幫我找到一位很有耐心的印傭姐姐。姐姐對老人家很好，我們全家都很滿意！',
    date: '2025/05/10'
  }
];